import { useTranslation } from '@eti/providers';
import { Card, LinkButton } from '@etg/wings';
import { Overlay } from '@eti/components';
import { css } from '@eti/styles';
import type { TripType } from '@eti/schema-types';
import type { BoundType } from '../../order-details/models';
import ItineraryBound from '../../order-details/components/overview/itinerary/drawer/ItineraryBound';
import { useToggle } from '../../../common/custom-hooks/toggle';

const cardStyles = css`
  margin-top: 16px;
`;

interface TripDetailsLinkProps {
  bounds: BoundType[];
  tripType: TripType;
}

const TripDetailsLink = ({ bounds, tripType }: TripDetailsLinkProps) => {
  const { t } = useTranslation();
  const { isOpen, handleOpen, handleClose } = useToggle(false);

  return (
    <>
      <LinkButton data-testid="show-trip-detail-link" onClick={handleOpen}>
        {t('YourSelectedTrip.Page.ShowTripDetail.Label')}
      </LinkButton>

      <Overlay.Drawer
        dataTestId="your-selected-trip-itinerary-drawer"
        handleClose={handleClose}
        isOpen={isOpen}
      >
        <Overlay.Header onClose={handleClose} title={t('IbeClient.TripInfo.Header')} />
        <Overlay.Content data-testid="itinerary-drawer-content">
          {bounds?.map((bound: BoundType, index: number) => (
            <Card
              className={cardStyles}
              data-testid={`trip-${bound.boundId}-details`}
              key={bound.boundId}
              padding={0}
            >
              <ItineraryBound
                boundId={bound.boundId}
                boundIndex={index}
                isSelected
                journeyType={tripType}
                segments={bound.segments}
              />
            </Card>
          ))}
        </Overlay.Content>
      </Overlay.Drawer>
    </>
  );
};

export default TripDetailsLink;
